import {
  GET_SKIN_TYPES,
  GET_SKIN_TYPES_SUCCESS,
  GET_SKIN_TYPES_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getSkinTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SKIN_TYPES:
      return { ...state, loading: true };
    case GET_SKIN_TYPES_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_SKIN_TYPES_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getSkinTypesReducer;
